import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

const ContentInputA = dynamic(() => import('./version-a'), { ssr: false })
const ContentInputB = dynamic(() => import('./version-b'), { ssr: false })

function useContentInputFeatureToggle() {
  const { query } = useRouter()
  // 刻意只捕捉 first render 的 query，因為之後 replace 網址可能會被蓋掉
  const ContentInput = useMemo(() => (query.editor === 'a' ? ContentInputA : ContentInputB), [])

  return ContentInput
}

export default useContentInputFeatureToggle
